import { request } from '../handleRequest';

export const buildRequestURL = (carePlanId, id, type, recurring) => {
  let url = `/care_plans/${carePlanId}/`;

  switch (type) {
    case 'Task':
      url += recurring ? `repeated_tasks/${id}` : `tasks/${id}`;
      break;
    case 'Appointment':
      url += recurring ? `repeated_appointments/${id}` : `appointments/${id}`;
      break;
    default:
      url = '/404';
  }

  return url;
};

export const deleteActivityApiWrapper = (
  requestProvider = request,
  buildRequestURLProvider = buildRequestURL
) => {
  return async (carePlanId, activityId, type, recurring) => {
    try {
      const url = buildRequestURLProvider(carePlanId, activityId, type, recurring);
      const response = await requestProvider(url, 'DELETE');

      const status = response.status;

      return { status };
    } catch (error) {
      return { status: 422, error };
    }
  };
};

export default deleteActivityApiWrapper(request, buildRequestURL);
